// extracted by mini-css-extract-plugin
export default {"container":"AttributionBox_container__NGKOc","content":"AttributionBox_content__C2QuT","numbers":"AttributionBox_numbers__67Ffo"};